import {
  MemberFeature,
  MemberFeatures,
  OrganizationFeatures,
  OrganizationFeature,
} from '@trello/product-features';

export function hasGold(products: number[]) {
  return MemberFeatures.isFeatureEnabled(MemberFeature.Crown, products[0]);
}

export function hasBCPowerups(organizations?: { products: number[] }[]) {
  return organizations?.some(({ products }) =>
    products.some((code) =>
      OrganizationFeatures.isFeatureEnabled(OrganizationFeature.Plugins, code),
    ),
  );
}
